import { ChangeEvent, useEffect } from "react";
import { Box, Grid, MenuItem } from "@mui/material";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { InputsProductionContract, InputsProductionSupervisor } from "src/Contexts/ReportProduction/ReportsProductionTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import { SelectedFiliaisAutoCompletedGeneric } from "src/Pages/components/AutoCompleted/Multiple/SelectedFiliais";
import { ComponentPrivate } from "src/Pages/components/ComponentPrivate/ComponentPrivate";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { DrawerFilterReport } from "src/Pages/components/DrawerFilterReport/DrawerFilterReport";

import { AutoCompleteSupervisorAll } from "../../../../../../components/AutoCompleted/AutoCompleteSupervisor";
import { SelectedAdministradorasGeneric } from "../../../../../../components/AutoCompleted/Multiple/SelectedAdministradoras";
import { SelectedModalidadesGeneric } from "../../../../../../components/AutoCompleted/Multiple/SelectedModalidades";
import { SelectedOperadorasGeneric } from "../../../../../../components/AutoCompleted/Multiple/SelectedOperadoras";

import { UseReportProductionContract } from "../Form/Hooks/UseReportProductionProducer";

export const DrawerFilterProductionSupervisor = () => {
  const { setActive_incluir, active_incluir } = useConfigPageContext();
  const { handleSubmit } = UseReportProductionContract();
  const { resetInputs } = useResetInputs(true);
  const { userPerfil } = useAuthContext();

  const { setValuesInputsProductionSupervisor, valuesInputsProductionSupervisor } = useContextReportsProduction();

  useEffect(() => setActive_incluir(true), [active_incluir]);

  const handleChange =
    (prop: keyof InputsProductionSupervisor) =>
      (event: ChangeEvent<HTMLInputElement>) => {
        setValuesInputsProductionSupervisor({
          ...valuesInputsProductionSupervisor,
          [prop]: event.target.value,
        });
      };

  return (
    <DrawerFilterReport onClear={resetInputs} onApply={handleSubmit}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          "& .MuiAutocomplete-root": { margin: 0 },
        }}
      >
        <Box>
          <DividerCore title="Período" sxStyle={{ margin: "0 0 16px 0" }} />

          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                label="Data inicial *"
                type="date"
                variant="outlined"
                sxStyle={{ margin: 0 }}
                value={valuesInputsProductionSupervisor?.start_date}
                onChange={handleChange("start_date")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                label="Data final *"
                type="date"
                variant="outlined"
                sxStyle={{ margin: 0 }}
                value={valuesInputsProductionSupervisor?.end_date}
                onChange={handleChange("end_date")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                select
                label="Tipo de data *"
                variant="outlined"
                sxStyle={{ margin: 0 }}
                value={valuesInputsProductionSupervisor?.type_date}
                onChange={handleChange("type_date")}
              >
                <MenuItem value="ASSINATURA">Assinatura</MenuItem>
                <MenuItem value="VIGENCIA">Vigência</MenuItem>
                <MenuItem value="EMISSAO">Emissão</MenuItem>
              </AppTextField>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <DividerCore title="Operadoras e Planos" sxStyle={{ margin: "0 0 16px 0" }} />
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <SelectedOperadorasGeneric fullWidth label="Operadoras" variant="outlined" />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <SelectedModalidadesGeneric fullWidth label="Modalidades" variant="outlined" />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <SelectedAdministradorasGeneric fullWidth label="Administradoras" variant="outlined" />
              </Box>
            </Grid>
          </Grid>
        </Box>

        <ComponentPrivate isView={userPerfil?.type_user !== "PRODUCER"}>
          <Box>
            <DividerCore title="Supervisor" sxStyle={{ margin: "0 0 16px 0" }} />
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} sm={4}>
                <AppTextField
                  fullWidth
                  select
                  label="Tipo de relatório"
                  variant="outlined"
                  sxStyle={{ margin: 0 }}
                  value={valuesInputsProductionSupervisor?.type_report}
                  onChange={handleChange("type_report")}
                >
                  <MenuItem value="ALL">Todos os supervisores</MenuItem>
                  <MenuItem value="UNIQUE">Supervisor específico</MenuItem>
                </AppTextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                  <AutoCompleteSupervisorAll
                    fullWidth
                    disabled={valuesInputsProductionSupervisor?.type_report === "ALL"}
                    label="Selecione o supervisor"
                    variant="outlined"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                  <SelectedFiliaisAutoCompletedGeneric fullWidth label="Filiais" variant="outlined" />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </ComponentPrivate>
      </Box>
    </DrawerFilterReport>
  );
};
